import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
} from 'react-bootstrap5';

import confirmAlert from 'components/new_ui/Alerts/confirm';

import { useContext } from 'components/Members/Programs/Views/Show/Context';

import Step from './Step';

export default function AiSessionStep({
  step, showStep, setShowStep,
}) {
  const { dispatch, actions } = useContext();

  const onStartSessionClick = () => {
    const event = new CustomEvent('ReturnToWorkFirstAiSession', {
      detail: {
        welcomeMessage: `Coach Laser Session Initiation Prompt
Parameters:
${step.title}: The specific topic or area of focus for the session
${step.description}: Brief description of what the topic covers and why it's relevant

Session Opening Instructions:
Welcome message:
"Hello and welcome to your 10-minute LeggUP laser coaching session! 
I'm excited to help you make the most of our focused time together. 
Today we're diving into ${step.title}."

Laser session agenda:

This laser session is designed to give you quick, actionable insights. Let's make every minute count!
Our Laser Session Agenda:
1. Quick Topic Check-In
 What's your biggest challenge or question around ${step.title} right now?
2. Focused Exploration
 We'll zero in on what matters most to you today and explore practical solutions or new perspectives.
3. Your Next Step
 You'll leave with one clear, actionable step you can take immediately.

First question:
"Let's jump right in - what's the most pressing thing about ${step.title} for you today?"        
        `,
      },
    });
    window.dispatchEvent(event);
  };

  const onCompleteClick = () => {
    confirmAlert(
      {
        title: 'Complete Step',
        text: 'Are you sure you want to complete this step?',
        confirmButtonText: 'Complete',
      },
      () => {
        actions.completeStep(dispatch, step.id, () => {
        });
      },
    );
  };

  return (
    <Step
      step={step}
      iconClassName="counting-icon bg-white"
      showStep={showStep}
      setShowStep={setShowStep}
    >
      <>
        <Button
          onClick={onStartSessionClick}
          variant="light"
          className="btn-reverse ms-lg-3 mb-3 mb-lg-0 step-action-btn"
        >
          Start Session
        </Button>

        {!step.completed && (
          <Button
            onClick={onCompleteClick}
            variant="light"
            className="btn-reverse ms-3 mb-3 mb-lg-0 step-action-btn"
          >
            Complete
          </Button>
        )}
      </>
    </Step>
  );
}

AiSessionStep.propTypes = {
  step: PropTypes.object.isRequired,
  showStep: PropTypes.bool.isRequired,
  setShowStep: PropTypes.func.isRequired,
};
